import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import ClipLoader from "react-spinners/dist/spinners/ClipLoader"

const WidgetExportDownloadNotification = ({ closeToast, t, theme }) => (
  <div className="text-center">
    <div style={{ margin: "5px 0" }}>
      <ClipLoader loading color={theme.primaryColor} size={25} />
    </div>
    {t("Widgets.Shared.ExportGenerating")}
    {/* <button onClick={closeToast}>Cancel download</button> */}
  </div>
)

WidgetExportDownloadNotification.propTypes = {
  t: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(WidgetExportDownloadNotification)



// WEBPACK FOOTER //
// ./src/components/layout/widget/WidgetExportDownloadNotification.jsx